import { useAuthContext } from "@/contexts/AuthContext";

export { type AuthState } from "@/hooks/useProvideAuth";

export const useAuth = () => useAuthContext();
